import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogAPI } from '../services/api';

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  // Sample blog data for demonstration
  const sampleBlog = {
    _id: id,
    title: 'सीता राम प्रथम मिलन की पावन कथा',
    content: `त्रेता युग में जब गुरु विश्वामित्र की आज्ञा से प्रभु श्री राम और लक्ष्मण जी पुष्प लेने के लिए जनकपुर की वाटिका में गए, तो वहाँ एक अद्भुत घटना घटी।

राजा जनक की पुष्प वाटिका अपने सौंदर्य के लिए प्रसिद्ध थी। वहाँ तरह-तरह के सुगंधित फूल खिले रहते थे। गुरु विश्वामित्र ने राम और लक्ष्मण से कहा था कि वे यज्ञ के लिए पुष्प लेकर आएं।

जब राम और लक्ष्मण वाटिका में पहुंचे, तो वहाँ का दृश्य अत्यंत मनोहारी था। चारों ओर रंग-बिरंगे फूल खिले हुए थे, भौंरे गुंजार कर रहे थे, और पक्षी मधुर गीत गा रहे थे।

उसी समय राजकुमारी सीता अपनी सखियों के साथ गौरी पूजन के लिए वाटिका में आई थीं। मिथिला की परंपरा के अनुसार, कुमारी कन्याएं माँ गौरी की पूजा करके अच्छे वर की कामना करती थीं।

जब सीता जी गौरी मंदिर में पूजा कर रही थीं, तभी प्रभु राम की दृष्टि उन पर पड़ी। यह त्रेता युग का सबसे पावन क्षण था - सीता और राम का प्रथम मिलन।

राम जी सीता के सौंदर्य और भक्ति भाव को देखकर मुग्ध हो गए। सीता जी भी राम के दिव्य रूप को देखकर अभिभूत हो गईं। यह प्रेम दर्शन मात्र से ही हो गया था।

इसी स्थान पर आज फुलहर धाम स्थित है, जहाँ सीता राम का प्रथम मिलन हुआ था। यह स्थान आज भी उसी पावनता से भरा हुआ है।

भक्तगण यहाँ आकर उस पावन क्षण को याद करते हैं और सीता राम के प्रेम की महिमा का गुणगान करते हैं। यह स्थान प्रेम, भक्ति और समर्पण का प्रतीक है।

फुलहर धाम में आने वाले श्रद्धालु इस पावन कथा को सुनकर धन्य हो जाते हैं और अपने जीवन में भी सीता राम के आदर्शों को अपनाने की प्रेरणा पाते हैं।`,
    category: 'रामकथा',
    author: { name: 'पंडित जी' },
    createdAt: new Date().toISOString(),
    image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800',
    tags: ['सीता राम', 'प्रथम मिलन', 'फुलहर धाम', 'पुष्प वाटिका']
  };

  const sampleRelatedBlogs = [
    {
      _id: '2',
      title: 'गौरी पूजन की विधि',
      category: 'धार्मिक शिक्षा',
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=300'
    },
    {
      _id: '3',
      title: 'मिथिला की सांस्कृतिक परंपराएं',
      category: 'मिथिला संस्कृति',
      image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=300'
    }
  ];

  useEffect(() => {
    fetchBlog();
  }, [id]);

  const fetchBlog = async () => {
    try {
      // For now, using sample blog. In production, uncomment the API call
      // const response = await blogAPI.getById(id);
      // setBlog(response.data);
      setBlog(sampleBlog);
      setRelatedBlogs(sampleRelatedBlogs);
    } catch (error) {
      console.error('Error fetching blog:', error);
      setBlog(sampleBlog); // Fallback to sample blog
      setRelatedBlogs(sampleRelatedBlogs);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('hi-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-mithila-bg flex items-center justify-center">
        <div className="text-center">
          <div className="loader mb-4"></div>
          <p className="text-mithila-text">ब्लॉग लोड हो रहा है...</p>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="min-h-screen bg-mithila-bg flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">📝</div>
          <h2 className="text-2xl font-bold text-gray-600 mb-4">ब्लॉग नहीं मिला</h2>
          <Link to="/blog" className="text-mithila-primary hover:underline">
            ब्लॉग सूची पर वापस जाएं
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-mithila-bg">
      {/* Breadcrumb */}
      <section className="py-4 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm">
            <Link to="/" className="text-mithila-primary hover:underline">होम</Link>
            <span className="mx-2 text-gray-500">›</span>
            <Link to="/blog" className="text-mithila-primary hover:underline">ब्लॉग</Link>
            <span className="mx-2 text-gray-500">›</span>
            <span className="text-gray-600">{blog.title}</span>
          </nav>
        </div>
      </section>

      {/* Blog Content */}
      <article className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <header className="mb-8">
            <div className="flex items-center justify-between mb-4">
              <span className="inline-block bg-mithila-primary/10 text-mithila-primary text-sm font-bold px-4 py-2 rounded-full">
                {blog.category}
              </span>
              <span className="text-sm text-gray-500">
                {formatDate(blog.createdAt)}
              </span>
            </div>
            
            <h1 className="text-3xl md:text-4xl font-serif font-bold text-mithila-text mb-4 leading-tight">
              {blog.title}
            </h1>
            
            <div className="flex items-center text-sm text-gray-600">
              <span className="mr-1">✍️</span>
              <span>{blog.author?.name || 'व्यवस्थापक'}</span>
            </div>
          </header>

          {/* Featured Image */}
          {blog.image && (
            <div className="mb-8">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-64 md:h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
          )}

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-mithila-secondary/20">
              <div className="text-gray-700 leading-relaxed space-y-4">
                {blog.content.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="text-base leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>

          {/* Tags */}
          {blog.tags && blog.tags.length > 0 && (
            <div className="mt-8 pt-8 border-t border-gray-200">
              <h3 className="text-lg font-bold text-mithila-text mb-4">टैग्स:</h3>
              <div className="flex flex-wrap gap-2">
                {blog.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-mithila-bg text-mithila-text px-3 py-1 rounded-full text-sm font-medium border border-mithila-secondary/20"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h3 className="text-lg font-bold text-mithila-text mb-4">साझा करें:</h3>
            <div className="flex space-x-4">
              <button className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700 transition">
                Facebook
              </button>
              <button className="bg-blue-400 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-500 transition">
                Twitter
              </button>
              <button className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-700 transition">
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      </article>

      {/* Related Blogs */}
      {relatedBlogs.length > 0 && (
        <section className="py-10 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-5">
            <h2 className="text-2xl font-serif font-bold text-mithila-text mb-6 text-center">
              संबंधित ब्लॉग
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {relatedBlogs.map((relatedBlog) => (
                <Link
                  key={relatedBlog._id}
                  to={`/blog/${relatedBlog._id}`}
                  className="group"
                >
                  <div className="bg-mithila-bg rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    {relatedBlog.image && (
                      <img
                        src={relatedBlog.image}
                        alt={relatedBlog.title}
                        className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    )}
                    <div className="p-6">
                      <span className="inline-block bg-mithila-secondary/10 text-mithila-secondary text-xs font-bold px-3 py-1 rounded-full mb-3">
                        {relatedBlog.category}
                      </span>
                      <h3 className="text-lg font-serif font-bold text-mithila-text group-hover:text-mithila-primary transition-colors">
                        {relatedBlog.title}
                      </h3>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Back to Blog */}
      <section className="py-8 bg-mithila-bg">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link
            to="/blog"
            className="inline-flex items-center bg-mithila-primary text-white px-6 py-3 rounded-lg hover:bg-red-700 transition font-bold"
          >
            ← सभी ब्लॉग देखें
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BlogDetail;